var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 7.61 5.691 32.781 35.556"
    },
    viewBox: "7.61 5.691 32.781 35.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#b289e9}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.726 23.948 2.967 4.431 12.698-4.671-2.957-4.435-12.708 4.675z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.456 25.212v16.035l13.423-4.942V25.633l-10.208 3.756a.474.474 0 0 1-.555-.181l-2.66-3.996zM7.61 23.702l12.709 4.677 2.954-4.436-12.696-4.672-2.967 4.431z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.09 36.305 13.424 4.942V25.281l-2.617 3.928a.472.472 0 0 1-.554.182L10.09 25.618v10.687zM11.754 18.703 24 23.211l12.256-4.508-6.133-2.256a7.402 7.402 0 0 1-6.124 3.207 7.404 7.404 0 0 1-6.124-3.206l-6.121 2.255z",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.691a6.519 6.519 0 0 0-6.511 6.511c0 3.59 2.92 6.511 6.511 6.511a6.518 6.518 0 0 0 6.511-6.511A6.52 6.52 0 0 0 24 5.691zm3.001 8.848a.47.47 0 0 1-.665.666L24 12.868l-2.336 2.336a.473.473 0 0 1-.666 0 .473.473 0 0 1 0-.666l2.336-2.336-2.336-2.336a.471.471 0 0 1 .666-.665L24 11.537l2.336-2.336a.47.47 0 1 1 .665.665l-2.336 2.336 2.336 2.337z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutStock);
export default __webpack_public_path__ + "static/media/out_stock.eb3db2041344d2dbc87c3a7efddee0f6.svg";
export { ForwardRef as ReactComponent };